export default __webpack_public_path__ + "static/media/r.201d262f.svg";